import Drill from "@drillflo/drillcore/lib/Drill";
import { useEffect, useState } from "react";
import convertToMarchingCoordinates from "../../hooks/convertToMarchingCoordinate";

export const useCoordinates = (
  drillDocumentData: any,
  drill: Drill,
  view: any
) => {
  const [coordinateSheetData, setCoordinateSheetData] = useState<any>([]);

  function processDrillData(
    drillDocumentData: any,
    drill: Drill,
    view: any,
    drillPages: any,
    performersFromDrill: any
  ) {
    if (!drillDocumentData || !drill || !drillPages || !performersFromDrill) {
      console.log("No pages or page data");
      return [];
    }

    const performerCoordinates: any[] = [];

    drillPages.forEach((page, pageIndex) => {
      const positions = page.performerPositions || page._performerPositions; // fallback if needed

      positions.forEach((position, performerId) => {
        const posToUse = position.position || position;

        let performer = performerCoordinates.find(
          (entry) => entry.performerId === performerId.id
        );

        if (!performer) {
          performer = { performerId: performerId.id, coordinates: [] };
          performerCoordinates.push(performer);
        }

        const marchingCoordinates = convertToMarchingCoordinates(
          Number(posToUse.horizontalStepsFrom50),
          Number(posToUse.verticalStepsFromCenter),
          drill.engine?.hashType || "HIGH_SCHOOL_PERFECT"
        );

        performer.coordinates.push({
          page: pageIndex,
          counts: drill.pages[pageIndex].counts,
          tempo: drill.pages[pageIndex].tempo,
          ...marchingCoordinates,
        });
      });
    });

    const performersById = Object.fromEntries(
      performersFromDrill.map((performer) => [performer.id, performer.name])
    );

    performerCoordinates.sort((a, b) => {
      const nameA = performersById[a.performerId] || "";
      const nameB = performersById[b.performerId] || "";
      return nameA.localeCompare(nameB);
    });

    return performerCoordinates;
  }

  return { coordinateSheetData, processDrillData };
};
